<template>
    <div class="work-wechat-detail">
        <div class="content">
            <div class="data-title">
                <div class="title-name">查看/编辑工作微信号</div>
            </div>
            <template v-if="hasPermission===1">
                <div class="text">基本信息</div>
                <div class="forms">
                    <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
                        <el-form-item label="工作微信号" prop="account">
                            <div class="input-con" v-if="permission.copy">
                                <el-input v-model="form.account" class="input" placeholder="请输入"  maxlength="20" clearable show-word-limit :disabled="!permission.edit"></el-input>
                                <div v-if="form.account" class="btn-copy" @click="onCopy(form.account)">复制</div>
                                <div v-else class="btn-copy btn-copy-dis" >复制</div>
                            </div>
                            <el-input v-else v-model="form.account" class="input" placeholder="请输入"  maxlength="11" clearable show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="微信号密码" prop="password">
                            <div class="input-con" v-if="permission.password">
                                <el-input
                                    type="text"
                                    style="display: none;"
                                    autocomplete="username">
                                    </el-input>
                                <el-input v-if="eye" v-model="form.password"  class="input" autocomplete="new-password"  placeholder="请输入" maxlength="20" :type="eye?'text':'password'" :readonly="!permission.edit">
                                    <i slot="suffix" class="i-eye" @click="onEye"></i>
                                </el-input>
                                <el-input v-else value='******' class="input" type="password" readonly >
                                    <i slot="suffix" class="i-eye-hide" @click="onEye"></i>
                                </el-input>
                                <div v-if="eye && permission.copy" class="btn-copy" @click="onCopy(form.password)">复制</div>
                                <div v-else class="btn-copy btn-copy-dis">复制</div>
                            </div>
                            <el-input v-else value='******' class="input" type="password" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="微信号实名人" class="t-label">
                            <template #label>
                                <div class="custom-label">微信号<br />实名人</div>
                            </template>
                            <el-input v-model="form.name" placeholder="请输入" clearable maxlength="30" type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="微信号 绑定手机号" prop="phone">
                            <template #label>
                                <div class="custom-label">微信号<br />绑定手机号</div>
                            </template>
                            <el-input v-model="form.phone" placeholder="请输入" maxlength="11" clearable show-word-limit :disabled="!permission.edit" @input="checkPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定手机号所属员工" class="t-label">
                            <template #label>
                                <div class="custom-label">绑定手机号<br />所属员工</div>
                            </template>
                            <el-input v-model="accountName" placeholder="自动识别" style="width: 204px;" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="微信号好友数" class="label-star" prop="friendsCount">
                            <template #label>
                                <div class="custom-label">微信号<br />好友数</div>
                            </template>
                            <el-input v-model="form.friendsCount" placeholder="请输入" clearable maxlength="8" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="微信号备注" class="t-label" prop="remarks">
                            <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="line"></div>
                    <p>更多信息</p>
                    <el-form :inline="true" class="form-list" size="small" label-width="96px">
                        <el-form-item label="创建时间："><div class="con">{{ form.createdTime || '-' }}</div></el-form-item>
                        <el-form-item label="创建人："><div class="con">{{ form.createdByName || '-' }}</div></el-form-item>
                        <el-form-item label="微信号状态：">
                            <div class="con">
                                <span v-if="form.statusLabel" :class="'icon-status icon-status-' + form.status"> {{ form.statusLabel}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="最后归属人："><div class="con">{{ form.ownerUserName || '-' }}</div></el-form-item>
                        <el-form-item label="更新时间："><div class="con">{{ form.updatedTime || '-' }}</div></el-form-item>
                        <el-form-item label="最近更新人："><div class="con">{{ form.updatedByName || '-' }}</div></el-form-item>
                        <el-form-item label="最后归属部门：">
                            <template #label>
                                <div class="custom-label">最后&nbsp;&nbsp;&nbsp;<br />归属部门：</div>
                            </template>
                            <div class="con">{{ form.ownerDeptName || '-' }}</div></el-form-item>
                        <el-form-item v-if="form.status==3 && form.cancelReason" label="注销原因："><div class="con">{{ form.cancelReason }}</div></el-form-item>
                        <el-form-item label="历史记录："  v-if="permission.history"><div class="con"><el-button type="primary" class="btn-look" @click="onHistory" plain size="mini">查看</el-button></div></el-form-item>
                    </el-form>

                </div>
            </template>
            <div v-else-if="hasPermission===0" class="no-permission">
                <div class="pic"></div>
                <div class="word">抱歉，您缺少权限</div>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info"  plain @click="onBack">返回</el-button>
                <!-- 归属人按钮 -->
                <template v-if="btnShow">
                    <el-button v-if="permission.delete" type="danger" @click="onDelete" :loading="btnDelete">删除</el-button>
                    <el-button v-if="permission.cancel" type="danger" @click="onCancel" :loading="btnCancel">注销账号</el-button>
                    <el-button v-if="permission.revoke" type="info" plain @click="onRevoke" :loading="btnRevoke">撤销</el-button>
                    <el-button v-if="permission.transfer" type="primary" @click="onTransfer" :loading="btnTransfer">转移</el-button>
                    <el-button v-if="permission.edit" type="primary" @click="onSave" :loading="btnSave">保存</el-button>
                </template>
                <!-- 审批人按钮 -->
                 <!-- <el-button type="primary" @click="onApprove" :loading="btnApprove">审批</el-button> -->
            </div>
        </div>
        <org-picker title="转移" :multiple="false" ref="orgPicker" @ok="selected" />
        <pop-report ref="popReport" :reportList="reportList" />
        <pop-cancel ref="popCancel" title="是否确认注销该工作微信号？" @setCancel="setCancel" />
        <pop-revoke ref="popRevoke" title="是否确认撤销该工作微信号？" @setRevoke="setRevoke" />
        <pop-delete ref="popDelete" title="是否确认删除？" @setDelete="setDelete" />
        <pop-approve ref="popApprove" title="审核" @setApprove="setApprove" />
        <pop-history ref="popHistory" title="历史记录" />
    </div>
</template>
<script>
import popApprove from "@/pages/assetManagement/common/popApprove";
import popHistory from "@/pages/assetManagement/common/popHistory";
import workWechatMixins from '@/pages/assetManagement/common/mixins/workWechat'
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';
export default {
    name: "workWechatDetail",
    mixins: [workWechatMixins],
    components: {popApprove,popHistory},
        computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            hasPermission:NaN,
            form: {
                account: '',
                password: '',
                name: '',
                friendsCount:'',
                remarks: '',
            },
            permission:{},
            dictionaries: { // 字典数据
                phone_operator: [],
            },
            rules: {
                account: [
                    { required: true, message: '请输入工作微信号', trigger: 'blur' },
                    { pattern: REGEX.WECHAT, message: '请输入正确的微信号',trigger: ['blur','change']  }
                ],
                password: [
                    { required: true, message: '请输入微信号密码', trigger: 'blur' }
                ],
                phone: [
                    { pattern: REGEX.PHONE, message: '请输入11位手机号',trigger: ['blur','change']  }
                ],
                friendsCount: [
                    { required: true, message: '请输入微信好友数', trigger: 'blur' },
                    { pattern: REGEX.COUNT, message: '请输入数字', trigger: 'change' }
                ]
            },
            selectIds:[],
            btnDelete:false,
            btnRevoke:false,
            btnCancel:false,
            btnTransfer:false,
            btnSave:false,
            btnApprove:false,
            btnShow:false,
            eye:  false,
            accountName:'',
            oldPassword:'',
            myPassword:'',
        }
    },
    activated() {
        this.fetchData()
        this.selectIds[0] = this.$route.query.id
        this.$refs.form && this.$refs.form.clearValidate()
    },
    created() {
        for(const type in this.dictionaries){
            this.getDictionaries(type)
        }
    },
    methods: {
        checkPhone(value){
            if(REGEX.PHONE.test(value)){
                let account = value
                this.$api.workPhoneFindName({account}).then(res => {
                    if (res.code == 0) {
                        this.accountName = res.data || '该手机号无登记'
                    }else{
                        this.accountName = '该手机号无登记'
                    }
                })
            }else{
                this.accountName = ''
            }
        },
        onEye(){
            if(!this.myPassword){
                const params = { subId: this.form.subId }
                this.$api.workWechatPassword(params).then(res => { 
                    this.eye = !this.eye
                    this.myPassword = res.data
                    this.form.password = this.myPassword
                })
            }else{
                this.eye = !this.eye
            }
        },
        onBack() {
            if (this.$route.query.back) {
                let backMenuIndex = localStorage.getItem('backMenuIndex')
                if (backMenuIndex) {
                    localStorage.removeItem('backMenuIndex')
                    localStorage.setItem('selectedMenuIndex',backMenuIndex); 
                }
            }
            this.$router.go(-1);
        },
        onDelete() {
            this.$refs.popDelete.show()
        },
        onCancel() {
            this.$refs.popCancel.show()
        },
        onRevoke() {
            this.$refs.popRevoke.show()
        },
        onTransfer(){
            this.$refs.orgPicker.show([],'user','transferUser')
        },
        onSave() {
            
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSave = true
                    // 判断是否是否被修改了
                    if(this.myPassword){
                        this.form.passwordChanged = (this.form.password != this.myPassword);
                    }else{
                        this.form.passwordChanged = false; 
                    }
                    this.form.phone = this.form.phone ? this.form.phone : null
                    console.log('>>',this.form.passwordChanged,this.myPassword,'??',this.form.password,this.form)
                    // return false
                    this.$api.workWechatSave(this.form).then((res) => {
                        if (res.code == 0) {
                            this.$message({ message: '修改成功', type: 'success' })
                            this.fetchData()
                        }
                    }).finally(() => {
                        this.btnSave = false
                    })
                }
            })
        },
        // 审批
        onApprove(){
            this.$refs.popApprove.show()
        },
        setApprove(e){
            console.log('审批：',e)
            this.btnApprove = true
            setTimeout(() => {
                this.btnApprove = false
                this.$message('没接口')
            }, 1000);
        },
        // 历史记录
        onHistory(){
            this.$refs.popHistory.show('workWechat')
        },
        fetchData() {
            this.myPassword = ''
            this.accountName = ''
            let id = this.$route.query.id
            this.form = {}
            this.$api.workWechatDetail({id}).then(res => {
                if (res.code == 0) {
                    this.form = res.data;
                    this.eye = false
                    this.oldPassword = res.data.password
                    this.form.phone && this.checkPhone(this.form.phone)
                    this.hasPermission = 1
                }else if(res.code == 501){
                    this.hasPermission = 0
                }
            })
            this.$api.checkPermission([id]).then(res => { 
                if (res.code == 0) {
                    this.permission =( res.data && res.data.accountPermissionMap && res.data.accountPermissionMap[id] ) || {}
                    console.log(JSON.stringify(this.permission))
                    this.btnShow = true
                }
            })

        },
        // 复制
        onCopy(text){
            if (text) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message({ message: '复制成功', type: 'success' });
                }).catch(err => {
                    this.$message.error('复制失败: ' + err);
                });
            } else {
                this.$message.warning('微信号为空，无法复制');
            }
        },


    }
}
</script>

<style lang="scss" src="@/pages/assetManagement/common/style/workWechat.scss" scoped />